window.onload = function() {
  var tabs = document.querySelectorAll('.scroll-to-collection-list-item');
  var sections = document.querySelectorAll('.scroll-to-collection-product-container');
  var tabHeight = 100; 
  
  var tabContainer = document.querySelector('.scroll-to-collection-list-wrapper');
  if (tabContainer) {
    tabHeight = tabContainer.offsetHeight + 50;
  }
  
  var sectionPositions = [];
  
  function updateSectionPositions() {
    sectionPositions = [];
    for (var i = 0; i < sections.length; i++) {
      sectionPositions.push({
        id: sections[i].id,
        top: sections[i].offsetTop,
        bottom: sections[i].offsetTop + sections[i].offsetHeight
      });
    }
  }
  
  updateSectionPositions();
  
  window.addEventListener('resize', function() {
    updateSectionPositions();
  });
  
  for (var i = 0; i < tabs.length; i++) {
    tabs[i].onclick = function() {
      var targetId = this.getAttribute('data-target');
      var targetElement = document.getElementById(targetId);
      
      if (targetElement) {
        // Scroll to section
        var targetPosition = targetElement.offsetTop - tabHeight;
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
        
        for (var j = 0; j < tabs.length; j++) {
          tabs[j].classList.remove('active');
        }
        this.classList.add('active');
      }
    };
  }
  
  function onScroll() {
    var scrollPosition = window.pageYOffset + tabHeight + 20;
    
    for (var i = 0; i < sectionPositions.length; i++) {
      var section = sectionPositions[i];
      
      if (scrollPosition >= section.top && scrollPosition <= section.bottom) {
        for (var j = 0; j < tabs.length; j++) {
          tabs[j].classList.remove('active');
          
          if (tabs[j].getAttribute('data-target') === section.id) {
            tabs[j].classList.add('active');
          }
        }
        
        break;
      }
    }
  }
  
  var throttleTimer;
  window.addEventListener('scroll', function() {
    clearTimeout(throttleTimer);
    throttleTimer = setTimeout(onScroll, 50);
  });
  
  if (tabs.length > 0) {
    tabs[0].classList.add('active');
  }
  
  onScroll();
};